import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from 'yup';
import commonFormMeta from "../commonMeta";
import { BankIDInputMeta, CorporateNameInputMeta } from '../commonMeta';

export interface ICommissionSettingsMeta {
  bankID: FormInputMeta,
  corporateName: FormInputMeta,
  transactionCode: FormInputMeta,
  mccGroup: FormInputMeta,
  transactionType: FormInputMeta,
  merchantCountry: FormInputMeta,
  paymentCanal: FormInputMeta,
  paymentScheme: FormInputMeta,
  cardUsage: FormInputMeta,
  binType: FormInputMeta,
  bankGroup: FormInputMeta,
  schema: any,
}

const commissionSettingsMeta = {} as ICommissionSettingsMeta ;

Object.assign(commissionSettingsMeta, {
  bankID: BankIDInputMeta,
  corporateName: CorporateNameInputMeta,
  transactionCode: commonFormMeta.transactionCode,
  mccGroup: commonFormMeta.mccGroup,
  transactionType: commonFormMeta.transactionType,
  merchantCountry: commonFormMeta.merchantCountry,
  paymentCanal: commonFormMeta.paymentCanal,
  paymentScheme: commonFormMeta.paymentScheme,
  cardUsage: commonFormMeta.cardUsage,
  binType: commonFormMeta.binType,
  bankGroup: commonFormMeta.bankGroup,
});

commissionSettingsMeta.schema = yup.object().shape(getValidationSchema(commissionSettingsMeta));

export default commissionSettingsMeta;